import { Requester } from './Requester';

export const SurveyReassignPrimary = async ({
    surveyId,
    contactId
}: {
    surveyId: string;
    contactId: string;
}): Promise<any> => {
    try {
        const response = await Requester<any | null>({
            path: `surveys/${surveyId}/reassignPrimary`,
            method: 'POST',
            payload: {
                primaryContact: contactId
            }
        });

        return response;
        // return response && Object.hasOwn(response, '_id') ? (response as any) : null;
    } catch (e) {
        console.error('Reassign primary request failed');
        return Promise.reject(e);
    }
};
